module.exports = __webpack_public_path__ + "media/Loops 110 Keys.16f2b631.wav";